import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DeferModule } from 'primeng/defer';
import { GalleriaModule } from 'primeng/galleria';

import { BrandedPageUiBrandedGalleryModule } from '@usheru-hff/branded-page/ui-branded-gallery';
import { SocialFeedComponent } from '@usheru-hff/channel-social-updates/feature-social-feed';
import { FooterComponent } from '@usheru-hff/core/footer';
import { LanguageSelectorComponent } from '@usheru-hff/core/language-selector';
import { HffCommonUiHeaderModule } from '@usheru-hff/hff-common/ui-header';
import { FeatureGalleryCarouselComponent } from '@usheru-hff/movie-detail/feature-gallery-carousel';
import { FeatureLaurelsCarouselComponent } from '@usheru-hff/movie-detail/feature-laurels-carousel';
import { FeatureMovieHeroComponent } from '@usheru-hff/movie-detail/feature-movie-hero';
import { MovieDetailFeatureShowtimesModule } from '@usheru-hff/movie-detail/feature-showtimes';
import { ShowtimeStreamingComponent } from '@usheru-hff/movie-detail/feature-showtimes-streaming';
import { MovieDetailFeatureStreamingModule } from '@usheru-hff/movie-detail/feature-streaming';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import { FeatureVideosCarouselComponent } from '@usheru-hff/movie-detail/feature-videos-carousel';
import {
  MovieCreditsComponent,
  MovieInfoCreditsComponent,
  MovieMoreInformationComponent,
  MovieRatingComponent,
  MovieReasonsToWatchComponent,
  MovieReviewsComponent,
  MovieSynopsisComponent,
  MovieTellFriendsComponent,
  MovieTitleComponent,
  SeeMoreComponent
} from '@usheru-hff/movie-detail/ui-movie-elements';
import { UiVideoCardComponent } from '@usheru-hff/movie-detail/ui-video-card';
import { NewsFeatureNewsCarouselModule } from '@usheru-hff/news/feature-news-carousel';
import { SharedFeatureSocialLinksModule } from '@usheru-hff/shared/feature-social-links';
import { SharedFeatureVideoThumbnailModule } from '@usheru-hff/shared/feature-video-thumbnail';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

import { TitleLocalizePipe } from '@usheru-hff/ui/pipes';

import { MovieTemplateAComponent } from './movie-template-a/movie-template-a.component';
import { MovieTemplateBComponent } from './movie-template-b/movie-template-b.component';
import { MovieTemplateCComponent } from './movie-template-c/movie-template-c.component';
import { AssetsLockerLinkComponent } from '@usheru-hff/access-locker/ui-assets-locker-link';
@NgModule({
  imports: [
    CommonModule,
    GalleriaModule,
    HffCommonUiHeaderModule,
    SharedFeatureSocialLinksModule,

    SharedUtilsImageModule,
    SharedUtilsModule,
    BrandedPageUiBrandedGalleryModule,
    FooterComponent,

    MovieCreditsComponent,
    MovieMoreInformationComponent,
    MovieReasonsToWatchComponent,
    MovieReviewsComponent,
    MovieRatingComponent,
    MovieSynopsisComponent,
    MovieTitleComponent,
    SeeMoreComponent,
    MovieInfoCreditsComponent,
    MovieTellFriendsComponent,
    AssetsLockerLinkComponent,

    MovieDetailFeatureShowtimesModule,
    MovieDetailFeatureStreamingModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    ShowtimeStreamingComponent,
    SocialFeedComponent,
    LoadingIndicatorComponent,
    SharedUiPictureModule,
    SharedFeatureVideoThumbnailModule,
    SharedUtilsImageModule,
    FeatureMovieHeroComponent,
    LanguageSelectorComponent,
    DeferModule,
    FontAwesomeModule,
    RouterModule.forChild([]),
    FeatureGalleryCarouselComponent,
    FeatureVideosCarouselComponent,
    FeatureLaurelsCarouselComponent,
    SwiperDirective,
    UiVideoCardComponent,
    NewsFeatureNewsCarouselModule,
    TitleLocalizePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [MovieTemplateAComponent, MovieTemplateBComponent, MovieTemplateCComponent],
  exports: [MovieTemplateAComponent, MovieTemplateBComponent, MovieTemplateCComponent]
})
export class BrandedPageUiBrandedTemplatesModule {}
